module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"客室がアップグレードしました！"},"en":{"title":"Your cabin was upgraded!"}}')
  delete Component.options._Ctor
}
